<template>
  <div class="select-list">
    <v-layout v-for="idAndName in idsAndNames" :key="idAndName.id" class="row">
      <v-flex xs11>
        {{ idAndName.name }}
      </v-flex>
      <v-flex xs1>
        <v-icon @click="$emit('onDelete', idAndName.id)">
          mdi-close-circle-outline
        </v-icon>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'AppDeletableColumn',
  props: {
    idsAndNames: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped lang="scss">
.select-list {
  padding-left: 10px;
  height: 100%;
  border: 1px solid black;
  overflow-y: scroll;
  width: 100%;
  overflow-x: hidden;
  padding-bottom: 10px;
}
.row {
  height: 22px;
}
</style>
